/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnnouncementNotificationAction } from './AnnouncementNotificationAction';
import {
    AnnouncementNotificationActionFromJSON,
    AnnouncementNotificationActionFromJSONTyped,
    AnnouncementNotificationActionToJSON,
} from './AnnouncementNotificationAction';

/**
 * 
 * @export
 * @interface AnnouncementNotification
 */
export interface AnnouncementNotification {
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<AnnouncementNotificationAction>}
     * @memberof AnnouncementNotification
     */
    actions: Array<AnnouncementNotificationAction>;
}

/**
 * Check if a given object implements the AnnouncementNotification interface.
 */
export function instanceOfAnnouncementNotification(value: object): value is AnnouncementNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function AnnouncementNotificationFromJSON(json: any): AnnouncementNotification {
    return AnnouncementNotificationFromJSONTyped(json, false);
}

export function AnnouncementNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnouncementNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(AnnouncementNotificationActionFromJSON)),
    };
}

export function AnnouncementNotificationToJSON(value?: AnnouncementNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(AnnouncementNotificationActionToJSON)),
    };
}

